import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute, PublicRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import { MasterViewExitBar } from "./components/MasterViewExitBar";
import Login from "@/pages/Login";
import SignUp from "@/pages/SignUp";
import SignupChoice from "@/pages/SignupChoice";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import SavedSearches from "@/pages/SavedSearches";
import Clinicians from "@/pages/Clinicians";
import Referrals from "@/pages/Referrals";
import ClinicianPortal from "@/pages/ClinicianPortal";
import ClinicAdminPortal from "@/pages/ClinicAdminPortal";
import ClinicSignup from "@/pages/ClinicSignup";
import ClinicianSignup from "@/pages/ClinicianSignup";
import AdminLogin from "@/pages/AdminLogin";
import AdminPortal from "@/pages/AdminPortal";
import AdminPreviewPortal from "@/pages/AdminPreviewPortal";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import GpPractices from "@/pages/GpPractices";
import Psychologists from "@/pages/Psychologists";
import Psychiatrists from "@/pages/Psychiatrists";
import PricingPage from "@/pages/PricingPage";
import Contact from "@/pages/Contact";
import Subscribe from "@/pages/Subscribe";
import AvailabilityManage from "@/pages/AvailabilityManage";
import AuthCallback from "@/pages/AuthCallback";
import Landing from "@/pages/Landing";
import DemoLinkPage, { AuthenticatedDemoPage, PublicDemoPage } from "@/pages/DemoLinkPage";
import PsychiatristAvailabilityDemo from "@/pages/PsychiatristAvailabilityDemo";
import RobotsMeta from "@/lib/RobotsMeta";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <RobotsMeta />
          <Routes>
            <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
            <Route path="/signup" element={<PublicRoute><SignupChoice /></PublicRoute>} />
            <Route path="/signup/gp" element={<PublicRoute><SignUp /></PublicRoute>} />
            <Route path="/forgot-password" element={<PublicRoute><ForgotPassword /></PublicRoute>} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/dashboard" element={<ProtectedRoute allow={["gp"]}><Dashboard /></ProtectedRoute>} />
        <Route path="/saved-searches" element={<ProtectedRoute allow={["gp"]}><SavedSearches /></ProtectedRoute>} />
            <Route path="/clinicians" element={<ProtectedRoute allow={["gp", "clinician", "clinic"]}><Clinicians /></ProtectedRoute>} />
            <Route path="/sample-dashboard" element={<ProtectedRoute allow={["gp"]}><AuthenticatedDemoPage page="dashboard" /></ProtectedRoute>} />
            <Route path="/sample-directory" element={<AuthenticatedDemoPage page="clinicians" />} />
            <Route path="/sample-referrals" element={<ProtectedRoute allow={["gp"]}><AuthenticatedDemoPage page="referrals" /></ProtectedRoute>} />
            <Route path="/referrals" element={<ProtectedRoute allow={["gp"]}><Referrals /></ProtectedRoute>} />
            <Route path="/clinician/login" element={<Navigate to="/login" replace />} />
            <Route path="/clinician/signup" element={<ClinicianSignup />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/clinician" element={<ProtectedRoute allow={["clinician"]}><ClinicianPortal /></ProtectedRoute>} />
          <Route path="/availability/manage" element={<AvailabilityManage />} />
            <Route path="/clinic/login" element={<Navigate to="/login" replace />} />
            <Route path="/clinic/signup" element={<ClinicSignup />} />
            <Route path="/clinic" element={<ProtectedRoute allow={["clinic"]}><ClinicAdminPortal /></ProtectedRoute>} />
            <Route path="/clinic/subscribe" element={<ProtectedRoute allow={["clinician", "clinic"]}><Subscribe /></ProtectedRoute>} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute redirectTo="/admin/login"><AdminPortal /></ProtectedRoute>} />
            <Route path="/admin/:section" element={<ProtectedRoute redirectTo="/admin/login" allow={["admin"]}><AdminPortal /></ProtectedRoute>} />
            <Route path="/admin/view-as/:previewRole/*" element={<ProtectedRoute redirectTo="/admin/login" allow={["admin"]}><AdminPreviewPortal /></ProtectedRoute>} />
            <Route path="/admin/preview/:previewRole/*" element={<ProtectedRoute redirectTo="/admin/login" allow={["admin"]}><AdminPreviewPortal /></ProtectedRoute>} />
            <Route path="/demo/access/:accessToken" element={<DemoLinkPage page="welcome" />} />
            <Route path="/demo/access/:accessToken/dashboard" element={<DemoLinkPage page="dashboard" />} />
            <Route path="/demo/access/:accessToken/clinicians" element={<DemoLinkPage page="clinicians" />} />
            <Route path="/demo/access/:accessToken/referral-tokens" element={<DemoLinkPage page="referrals" />} />
            <Route path="/demo" element={<PublicDemoPage page="welcome" />} />
            <Route path="/demo/dashboard" element={<PublicDemoPage page="dashboard" />} />
            <Route path="/demo/clinicians" element={<PublicDemoPage page="clinicians" />} />
            <Route path="/demo/referrals" element={<PublicDemoPage page="referrals" />} />
            <Route path="/demo/psychiatrist-availability" element={<PsychiatristAvailabilityDemo />} />
            <Route path="/proxy/:previewPort/demo/psychiatrist-availability" element={<PsychiatristAvailabilityDemo />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/gp-practices" element={<GpPractices />} />
            <Route path="/psychologists" element={<Psychologists />} />
            <Route path="/psychiatrists" element={<Psychiatrists />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/" element={<Landing />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        <MasterViewExitBar />
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
